module.exports = __webpack_public_path__ + "static/media/congratulate_map.c1549c25.svg";